module.exports = __webpack_public_path__ + "img/bf2b65f2e304724f1fcc7ba38d2f8b42.png";